// Polyfill for findDOMNode to support react-quill with React 18+
// IMPORTANT: This file must be imported FIRST in index.js, before any other imports

// Create findDOMNode implementation
const findDOMNodeImpl = function(componentOrElement) {
  if (componentOrElement == null) {
    return null;
  }
  
  // If it's already a DOM node, return it
  if (componentOrElement.nodeType === 1 || componentOrElement.nodeType === 3) {
    return componentOrElement;
  }
  
  // Try to get the DOM node from React component
  try {
    // Check for refs (React 18+ pattern)
    if (componentOrElement.ref) {
      const ref = typeof componentOrElement.ref === 'function' 
        ? componentOrElement.ref() 
        : componentOrElement.ref?.current;
      if (ref && (ref.nodeType === 1 || ref.nodeType === 3)) {
        return ref;
      }
    }
    
    // Try legacy refs
    if (componentOrElement.refs) {
      for (const key in componentOrElement.refs) {
        const ref = componentOrElement.refs[key];
        if (ref && (ref.nodeType === 1 || ref.nodeType === 3)) {
          return ref;
        }
      }
    }
    
    // Try to find the root DOM element (legacy React)
    if (componentOrElement.base || componentOrElement._hostNode) {
      return componentOrElement.base || componentOrElement._hostNode;
    }
  } catch (e) {
    // Silently fail - this is a best-effort polyfill
    console.warn('findDOMNode polyfill warning:', e.message);
  }
  
  return null;
};

// Patch react-dom at runtime
// We'll do this after the module loads to avoid webpack static analysis issues
setTimeout(() => {
  try {
    // Use require to avoid webpack static analysis
    const ReactDOM = require('react-dom');
    if (ReactDOM && typeof ReactDOM.findDOMNode === 'undefined') {
      Object.defineProperty(ReactDOM, 'findDOMNode', {
        value: findDOMNodeImpl,
        writable: true,
        configurable: true,
        enumerable: false
      });
    }
    
    // Also patch default export if it exists
    if (ReactDOM.default && typeof ReactDOM.default.findDOMNode === 'undefined') {
      Object.defineProperty(ReactDOM.default, 'findDOMNode', {
        value: findDOMNodeImpl,
        writable: true,
        configurable: true,
        enumerable: false
      });
    }
  } catch (e) {
    console.warn('Could not patch react-dom:', e);
  }
}, 0);

// Also try to patch immediately using dynamic import
import('react-dom').then((ReactDOM) => {
  if (ReactDOM && typeof ReactDOM.findDOMNode === 'undefined') {
    Object.defineProperty(ReactDOM, 'findDOMNode', {
      value: findDOMNodeImpl,
      writable: true,
      configurable: true,
      enumerable: false
    });
  }
  
  if (ReactDOM.default && typeof ReactDOM.default.findDOMNode === 'undefined') {
    Object.defineProperty(ReactDOM.default, 'findDOMNode', {
      value: findDOMNodeImpl,
      writable: true,
      configurable: true,
      enumerable: false
    });
  }
}).catch(() => {
  // Ignore errors
});
